var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C13.7909 10 12 11.7909 12 14C12 16.2091 13.7909 18 16 18Z",
    stroke: "#105099",
    strokeWidth: 4,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C30.2091 18 32 16.2091 32 14C32 11.7909 30.2091 10 28 10C25.7909 10 24 11.7909 24 14C24 16.2091 25.7909 18 28 18Z",
    stroke: "#105099",
    strokeWidth: 4,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C24.2091 22 26 20.2091 26 18C26 15.7909 24.2091 14 22 14C19.7909 14 18 15.7909 18 18C18 20.2091 19.7909 22 22 22Z",
    stroke: "#105099",
    strokeWidth: 4,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34C8 30.6863 10.6863 28 14 28H18C21.3137 28 24 30.6863 24 34",
    stroke: "#105099",
    strokeWidth: 4,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34C20 30.6863 22.6863 28 26 28H30C33.3137 28 36 30.6863 36 34",
    stroke: "#105099",
    strokeWidth: 4,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleBlue);
export default __webpack_public_path__ + "static/media/people-blue.2c266f6e9d0fda13fdc1429ef3227930.svg";
export { ForwardRef as ReactComponent };